export type Initiative = {
  id: string;
  topic: string;
  title: string;
  description: string;
  period: string;
  system: string;
  landscapeStage?: "SOURCE" | "EXTRACT" | "PROCESS" | "USE";
  context?: string;
  status?: "Gepland" | "In uitvoering" | "Afgerond";
  startDate?: string;
  endDate?: string;
};

export function planningPeriods(initiatives: Initiative[], count = 5) {
  const now = new Date();
  const currentQuarter = Math.floor(now.getMonth() / 3) + 1;
  const generated = Array.from({ length: count }, (_, offset) => {
    const quarterIndex = currentQuarter - 1 + offset;
    return `Q${quarterIndex % 4 + 1} ${now.getFullYear() + Math.floor(quarterIndex / 4)}`;
  });
  return Array.from(new Set([
    ...generated,
    ...initiatives.map(item => item.period).filter(value => /^Q[1-4] \d{4}$/.test(value)),
  ]));
}
